interface sharedReducerInitialState {
  isLoading: boolean;
  token: null | string;
  user: any;
  isSidebarExpanded: boolean;
}

const initialState: sharedReducerInitialState = {
  isLoading: false,
  token: null,
  user: null,
  isSidebarExpanded: true,
};

export const SHARED_REDUCER_ACTIONS = {
  LOADING: "LOADING",
  SAVE_TOKEN: "SAVE_TOKEN",
  LOGOUT: "LOGOUT",
  SAVE_USER_DATA: "SAVE_USER_DATA",
  SET_EXPAND_SIDEBAR: "SET_EXPAND_SIDEBAR",
};

const sharedReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case SHARED_REDUCER_ACTIONS.LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SAVE_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.LOGOUT:
      return {
        ...state,
        token: null,
        isLoading: false,
        user: null,
        permissions: [],
      };
    case SHARED_REDUCER_ACTIONS.SAVE_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };
    case SHARED_REDUCER_ACTIONS.SET_EXPAND_SIDEBAR:
      return {
        ...state,
        isSidebarExpanded: action.payload,
      };

    default:
      return state;
  }
};

export default sharedReducer;
